// GENERATED FILE — DO NOT EDIT.
// The newest published version, re-exported under stable names: this is what
// the package's synchronous API validates against.
// Regenerate with: pnpm gen
// A guard test (test/schemas-generated.test.ts) fails if this file drifts.

export {
  specVersion,
  eventSchema,
  feedSchema,
  eventRecommendedSchema,
  feedRecommendedSchema,
} from "./v0.6/schemas.js";

export {
  validateEvent,
  validateFeed,
  checkEventRecommended,
  checkFeedRecommended,
} from "./v0.6/validators.compiled.js";
